import {Checker} from "./checker";

/**
 * Collection kit
 */
export class CollectionKit {

  /**
   * Split array
   *
   * @param colls collections
   * @param size  The size of result array
   * @return List
   */
  public static split<T>(colls: Array<T>, size: number): Array<Array<T>> {
    if (Checker.empty(colls))
      return [];
    if (size <= 0)
      throw new Error('The size must > 0');

    const rets = [];
    let items = [];

    for (const coll of colls) {
      items.push(coll);
      if (size == items.length) {
        rets.push(items);
        items = [];
      }
    }
    if (0 != items.length)
      rets.push(items);
    return rets;
  }

  /**
   * Part array
   *
   * @param colls collections
   * @param parts Part length
   * @return List
   */
  public static parts<T>(colls: Array<T>, parts: number): Array<Array<T>> {
    if (Checker.empty(colls)) {
      return [];
    }
    if (parts <= 0)
      throw new Error('The parts length must > 0');
    if (colls.length <= parts) {
      return [colls];
    }
    const rets = [];
    let items = [];

    const pnum = Math.floor(colls.length / parts);
    for (const coll of colls) {
      items.push(coll);
      if (items.length == pnum) {
        rets.push(items);
        if (rets.length < parts)
          items = [];
      }
    }
    return rets;
  }
}
